export const GET_specifyDepartments = ({ departments }) => (department_id) => {
  return departments.filter((department) => {
    return department.id === department_id
  })
}
